/**
 * Apollo operation contexts for calls whose screen shows its own error.
 * This file has no generated-type imports, so screens and their tests can
 * import it without loading graphql/types.
 */
export type ApolloCallerErrorContext = {
  expectedGraphQLErrorCodes?: ReadonlyArray<string>;
  preserveErrorForCaller?: boolean;
  reportUnexpectedPreservedErrors?: boolean;
};

export const PRESERVE_ERROR_FOR_CALLER_CONTEXT = Object.freeze({
  preserveErrorForCaller: true,
});

export const getPreserveExpectedErrorsForCallerContext = ({
  expectedGraphQLErrorCodes,
}: {
  expectedGraphQLErrorCodes: ReadonlyArray<string>;
}): Readonly<ApolloCallerErrorContext> =>
  Object.freeze({
    expectedGraphQLErrorCodes: Array.from(
      new Set(expectedGraphQLErrorCodes.filter(Boolean))
    ),
    preserveErrorForCaller: true,
    reportUnexpectedPreservedErrors: true,
  });

/**
 * Default context for a call whose screen shows its own error text with
 * `getUserFacingErrorText` (wave 1, Oct 19 2026). The error stays on the
 * screen instead of opening /500. Input and permission refusals are not sent
 * to Sentry; network failures and other codes are still reported.
 */
export const CALLER_HANDLED_USER_ERROR_CONTEXT =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: ["BAD_USER_INPUT", "FORBIDDEN"],
  });

